module.exports = __webpack_public_path__ + "static/img/fefco203_1.9a2b83f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco203_1.png
// module id = 4oSD
// module chunks = 0